import React from "react";
import Carte from "./Carte.js";
import { jsPDF } from "jspdf";
import { WIDTH, HEIGHT, OX, OY } from "../parametres";

function telechargerGrille(list) {
    const doc = new jsPDF({
        orientation: "l",
    });

    list.forEach((carte, index) => {
        if (index !== 0 && index % 6 === 0) {
            doc.addPage();
        }
        const deltaX = WIDTH * 10 * ((index % 6) % 3);
        const deltaY = HEIGHT * 10 * Math.floor((index % 6) / 3);
        doc.addImage(carte, OX + deltaX, OY + deltaY, WIDTH * 10, HEIGHT * 10);
        doc.rect(OX + deltaX, OY + deltaY, WIDTH * 10, HEIGHT * 10);
    });
    doc.save("mur-sonore.pdf");
}
function Output({ canvasList, removeCarte }) {
    function handleClick(e) {
        e.preventDefault();
        telechargerGrille(canvasList);
    }
    return (
        canvasList.length !== 0 && (
            <div className="container">
                <div className="card">
                    <div className="card-header text-center">Aperçu</div>
                    <div className="container text-center my-2">
                        <button
                            className="btn btn-success"
                            onClick={handleClick}
                        >
                            Télécharger la grille
                        </button>
                    </div>
                    <div className="row row-cols-1 row-cols-md-3 mt-2 g-4">
                        {canvasList.map((canvas, index) => (
                            <Carte
                                key={index}
                                canvas={canvas}
                                removeCarte={(_) => removeCarte(index)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        )
    );
}

export default Output;
